import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { CtaPanel } from '@/components/generals/cta-panel'
import { HomeHero } from '@/components/home/home-hero'
import { TrustMarquee } from '@/components/home/trust-marquee'
import { WhatWeDo } from '@/components/home/what-we-do'
import { FullService } from '@/components/home/full-service'
import { Testimonials } from '@/components/home/testimonials'
import { Numbers } from '@/components/home/numbers'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HomeHero />
            <TrustMarquee />
            <WhatWeDo />
            <FullService />
            <Testimonials />
            <Numbers />
            <CtaPanel />
        </Layout>
    )
}

export default Home
